// import { useState, useEffect, useRef, useCallback } from "react";

// import {
//   ArrowRight,
//   ChevronLeft,
//   ChevronRight,
//   Newspaper,
//   FileText,
//   Globe2,
//   Building2,
//   Mic2,
// } from "lucide-react";

// import heroBg from "../assets/hero-bg.png";
// import { fetchBanners } from "../api/bannerApi";
// import { fetchTicker } from "../api/tickerApi";

// const TICKER_ICONS = [Globe2, FileText, Newspaper, Building2, Mic2];

// export default function HeroSection() {
//   // ---- Ticker Data (ab DB se aata hai) ----
//   const [tickerRaw, setTickerRaw] = useState([]);
//   const [tickerLoading, setTickerLoading] = useState(true);

//   useEffect(() => {
//     let isMounted = true;

//     fetchTicker()
//       .then((items) => {
//         if (!isMounted) return;
//         setTickerRaw(items);
//       })
//       .catch((err) => {
//         console.error("Failed to load ticker:", err);
//       })
//       .finally(() => {
//         if (isMounted) setTickerLoading(false);
//       });

//     return () => {
//       isMounted = false;
//     };
//   }, []);

//   const tickerData = tickerRaw.map((item, i) => ({
//     text: item.text,
//     link: item.link,
//     isPdf: item.isPdf,
//     icon: TICKER_ICONS[i % TICKER_ICONS.length],
//   }));

//   const horizontalTicker =
//     tickerData.length > 0 ? [...tickerData, ...tickerData] : [];

//   // ---- Slider Data (banners, DB se aata hai) ----
//   const [originalCards, setOriginalCards] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     let isMounted = true;

//     fetchBanners()
//       .then((banners) => {
//         if (!isMounted) return;
//         const mapped = banners.map((b) => ({
//           img: b.image,
//           title: b.title,
//           date: "",
//           link: b.link,
//         }));
//         setOriginalCards(mapped);
//       })
//       .catch((err) => {
//         console.error("Failed to load banners:", err);
//       })
//       .finally(() => {
//         if (isMounted) setLoading(false);
//       });

//     return () => {
//       isMounted = false;
//     };
//   }, []);

//   // Build infinite loop cards: [last, ...originals, first]
//   const cards =
//     originalCards.length > 0
//       ? [originalCards[originalCards.length - 1], ...originalCards, originalCards[0]]
//       : [];

//   const [currentIndex, setCurrentIndex] = useState(1); // start at first real slide (index 1)
//   const [isTransitioning, setIsTransitioning] = useState(true);
//   const [isPaused, setIsPaused] = useState(false);

//   const touchStartX = useRef(0);
//   const touchDeltaX = useRef(0);

//   // Next slide
//   const handleNext = useCallback(() => {
//     setIsTransitioning(true);
//     setCurrentIndex((prev) => prev + 1);
//   }, []);

//   // Previous slide
//   const handlePrev = useCallback(() => {
//     setIsTransitioning(true);
//     setCurrentIndex((prev) => prev - 1);
//   }, []);

//   // Auto-play
//   useEffect(() => {
//     if (isPaused || cards.length === 0) return;
//     const timer = setInterval(() => handleNext(), 5000);
//     return () => clearInterval(timer);
//   }, [isPaused, currentIndex, cards.length, handleNext]);

//   // Handle loop wrap-around without transition
//   const handleTransitionEnd = () => {
//     const lastIndex = cards.length - 1;
//     // If we're at the cloned first slide (index = lastIndex), jump to real first (index 1)
//     if (currentIndex === lastIndex) {
//       setIsTransitioning(false);
//       setCurrentIndex(1);
//       setTimeout(() => setIsTransitioning(true), 50);
//     }
//     // If we're at the cloned last slide (index = 0), jump to real last (index = originalCards.length)
//     else if (currentIndex === 0) {
//       setIsTransitioning(false);
//       setCurrentIndex(originalCards.length);
//       setTimeout(() => setIsTransitioning(true), 50);
//     }
//   };

//   const onTouchStart = (e) => {
//     touchStartX.current = e.touches[0].clientX;
//     touchDeltaX.current = 0;
//     setIsPaused(true);
//   };

//   const onTouchMove = (e) => {
//     touchDeltaX.current = e.touches[0].clientX - touchStartX.current;
//   };

//   const onTouchEnd = () => {
//     if (touchDeltaX.current < -40) handleNext();
//     else if (touchDeltaX.current > 40) handlePrev();
//     touchDeltaX.current = 0;
//     setIsPaused(false);
//   };

//   return (
//     <section
//       className="hero-section relative mb-16 sm:mb-20 bg-no-repeat bg-bottom"
//       style={{
//         background: "#FAF7F2",
//         backgroundSize: "cover",
//         backgroundPosition: "center bottom",
//         backgroundAttachment: "scroll",
//       }}
//     >
//       <div className="mx-auto px-4 sm:px-6 py-10 sm:py-16 lg:py-10">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
//           {/* LEFT CONTENT */}
//           <div className="space-y-4 sm:space-y-6">
//             <h1 className="text-3xl sm:text-4xl lg:text-4xl font-bold leading-tight text-gray-900">
//               The Voice of <span className="text-[#da2128]">Indian Industry</span>
//             </h1>

//             <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#faa61a] leading-tight !mt-[10px]">
//               Shaping Bharat's Future
//             </h2>

//             <p className="text-[15px] sm:text-[18px] text-gray-600 max-w-lg leading-relaxed">
//               The Associated Chambers of Commerce & Industry of India (ASSOCHAM) has been at the forefront of strengthening India's economic landscape for over a century.
//             </p>

//             <div className="flex flex-wrap gap-4 pt-2 sm:pt-4">
//               <a
//                 href="#about-us"
//                 className="inline-flex items-center gap-2 px-6 py-3 sm:px-8 sm:py-3.5 hover:bg-[#f59c00] hover:text-white font-semibold rounded-xl border-2 border-[#f7941d] hover:border-white transition-all duration-300 text-sm sm:text-base"
//               >
//                 Explore
//                 <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
//               </a>
//             </div>
//           </div>

//           {/* RIGHT SIDE - SLIDER */}
//           <div className="relative w-full">
//             <div
//               className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl"
//               style={{ boxShadow: "2px 2px 2px 2px #9c9999" }}
//               onMouseEnter={() => setIsPaused(true)}
//               onMouseLeave={() => setIsPaused(false)}
//               onTouchStart={onTouchStart}
//               onTouchMove={onTouchMove}
//               onTouchEnd={onTouchEnd}
//             >
//               <div className="relative h-[240px] sm:h-[340px] md:h-[430px] lg:h-[440px] rounded-2xl sm:rounded-3xl">
//                 {loading && (
//                   <div className="flex items-center justify-center h-full w-full bg-gray-100 animate-pulse text-gray-400 text-sm">
//                     Loading...
//                   </div>
//                 )}

//                 {!loading && cards.length === 0 && (
//                   <div className="flex items-center justify-center h-full w-full bg-gray-100 text-gray-400 text-sm">
//                     No banners found
//                   </div>
//                 )}

//                 {!loading && cards.length > 0 && (
//                   <div
//                     className="flex h-full w-full"
//                     onTransitionEnd={handleTransitionEnd}
//                     style={{
//                       transform: `translateX(-${currentIndex * 100}%)`,
//                       transition: isTransitioning
//                         ? "transform 1000ms cubic-bezier(0.4, 0, 0.2, 1)"
//                         : "none",
//                     }}
//                   >
//                     {cards.map((card, i) => (
//                       <div key={i} className="relative h-full w-full shrink-0">
//                         <img
//                           src={card.img}
//                           alt={card.title}
//                           className="w-full h-full object-cover object-center"
//                           loading="eager"
//                         />
//                         <div className="absolute inset-0" />
//                         <div className="absolute bottom-2 left-3 right-3 sm:bottom-3 sm:left-5 sm:right-5 text-white">
//                           <div className="font-serif text-[10px] sm:text-xs lg:text-sm leading-snug bg-black/60 backdrop-blur-md px-2 py-1 sm:px-2.5 sm:py-1.5 rounded-md inline-block max-w-full line-clamp-2">
//                             {card.title}
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* Left & Right Navigation Arrows */}
//                 {!loading && cards.length > 0 && (
//                   <>
//                     <button
//                       onClick={handlePrev}
//                       className="absolute left-2 sm:left-3 top-1/2 -translate-y-1/2 z-10 p-1.5 sm:p-2 rounded-full bg-black/40 backdrop-blur-sm text-white hover:bg-black/70 hover:scale-110 transition-all duration-300 focus:outline-none group"
//                       aria-label="Previous slide"
//                     >
//                       <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6 group-hover:scale-110 transition-transform" />
//                     </button>
//                     <button
//                       onClick={handleNext}
//                       className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 z-10 p-1.5 sm:p-2 rounded-full bg-black/40 backdrop-blur-sm text-white hover:bg-black/70 hover:scale-110 transition-all duration-300 focus:outline-none group"
//                       aria-label="Next slide"
//                     >
//                       <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6 group-hover:scale-110 transition-transform" />
//                     </button>
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Floating Ticker */}
//       <div className="absolute bottom-0 left-0 w-full z-20 translate-y-1/2 px-3 sm:px-6">
//         <div className="max-w-8xl mx-auto">
//           <div className="bg-[#FFFFFF] backdrop-blur-xl border border-[#FFFFFF] shadow-2xl rounded-xl sm:rounded-2xl overflow-hidden">
//             <div className="flex items-center pr-2 sm:pr-[18px] min-w-0">
//               {/* LIVE UPDATE LABEL */}
//               <div className="bg-[#da2128]/50 hover:bg-[#da2128] hover:text-white px-2.5 sm:px-4 py-3 sm:py-4 flex items-center gap-1.5 sm:gap-2 font-semibold text-[10px] sm:text-xs md:text-sm whitespace-nowrap rounded-r-xl sm:rounded-r-2xl shadow-lg shrink-0">
//                 <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-[#FFFFFF] rounded-full animate-pulse" />
//                 <span className="hidden xs:inline">LIVE UPDATES</span>
//                 <span className="xs:hidden">LIVE UPDATES</span>
//               </div>

//               {/* TICKER */}
//               <div className="flex-1 overflow-hidden px-2 sm:px-4 min-w-0">
//                 {tickerLoading && (
//                   <div className="py-2.5 sm:py-3 text-xs sm:text-sm text-gray-400">
//                     Loading updates...
//                   </div>
//                 )}

//                 {!tickerLoading && horizontalTicker.length === 0 && (
//                   <div className="py-2.5 sm:py-3 text-xs sm:text-sm text-gray-400">
//                     No updates found
//                   </div>
//                 )}

//                 {!tickerLoading && horizontalTicker.length > 0 && (
//                   <div className="flex items-center gap-5 sm:gap-8 whitespace-nowrap animate-[tickerHorizontal_40s_linear_infinite] hover:[animation-play-state:paused] py-2.5 sm:py-3">
//                     {horizontalTicker.map((item, i) => {
//                       const Icon = item.icon;

//                       return (
//                         <a
//                           key={i}
//                           href={item.link || "#knowledge"}
//                           target={item.link ? "_blank" : undefined}
//                           rel={item.link ? "noopener noreferrer" : undefined}
//                           className="flex items-center gap-2 text-gray-700 hover:text-[#B5121B] transition-colors m-[5px] shrink-0"
//                         >
//                           <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" />
//                           <span className="text-xs sm:text-sm font-medium">
//                             {item.text}
//                           </span>
//                           {item.isPdf && (
//                             <span className="text-[9px] sm:text-[10px] font-bold text-[#da2128] border border-[#da2128] rounded px-1 leading-4">
//                               PDF
//                             </span>
//                           )}
//                         </a>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes tickerHorizontal {
//           0% {
//             transform: translateX(0);
//           }
//           100% {
//             transform: translateX(-50%);
//           }
//         }

//         .hero-section img {
//           max-width: 100%;
//         }

//         @media (max-width: 639px) {
//           .hero-section {
//             background-attachment: scroll !important;
//           }
//         }

//         @media (min-width: 1024px) {
//           .hero-section {
//             background-attachment: fixed;
//           }
//         }
//       `}</style>
//     </section>
//   );
// }





// new new code 









import { useState, useEffect, useRef, useCallback } from "react";

import {
  ArrowRight,
  ChevronLeft,
  ChevronRight,
  Newspaper,
  FileText,
  Globe2,
  Building2,
  Mic2,
} from "lucide-react";

import heroBg from "../assets/hero-bg.png";
import { fetchBanners } from "../api/bannerApi";
import { fetchTicker } from "../api/tickerApi";

const TICKER_ICONS = [Globe2, FileText, Newspaper, Building2, Mic2];

export default function HeroSection() {
  // ---- Ticker Data (ab DB se aata hai) ----
  const [tickerRaw, setTickerRaw] = useState([]);
  const [tickerLoading, setTickerLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    fetchTicker()
      .then((items) => {
        if (!isMounted) return;
        setTickerRaw(items);
      })
      .catch((err) => {
        console.error("Failed to load ticker:", err);
      })
      .finally(() => {
        if (isMounted) setTickerLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const tickerData = tickerRaw.map((item, i) => ({
    text: item.text,
    link: item.link,
    isPdf: item.isPdf,
    icon: TICKER_ICONS[i % TICKER_ICONS.length],
  }));

  const horizontalTicker =
    tickerData.length > 0 ? [...tickerData, ...tickerData] : [];

  // ---- Slider Data (banners, DB se aata hai) ----
  const [originalCards, setOriginalCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    fetchBanners()
      .then((banners) => {
        if (!isMounted) return;
        const mapped = banners.map((b) => ({
          img: b.image,
          title: b.title,
          date: "",
          link: b.link,
        }));
        setOriginalCards(mapped);
      })
      .catch((err) => {
        console.error("Failed to load banners:", err);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  // Build infinite loop cards: [last, ...originals, first]
  const cards =
    originalCards.length > 0
      ? [originalCards[originalCards.length - 1], ...originalCards, originalCards[0]]
      : [];

  const [currentIndex, setCurrentIndex] = useState(1); // start at first real slide (index 1)
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [isPaused, setIsPaused] = useState(false);

  const touchStartX = useRef(0);
  const touchDeltaX = useRef(0);

  // Next slide
  const handleNext = useCallback(() => {
    setIsTransitioning(true);
    setCurrentIndex((prev) => prev + 1);
  }, []);

  // Previous slide
  const handlePrev = useCallback(() => {
    setIsTransitioning(true);
    setCurrentIndex((prev) => prev - 1);
  }, []);

  // Auto-play
  useEffect(() => {
    if (isPaused || cards.length === 0) return;
    const timer = setInterval(() => handleNext(), 5000);
    return () => clearInterval(timer);
  }, [isPaused, currentIndex, cards.length, handleNext]);

  // Handle loop wrap-around without transition
  const handleTransitionEnd = () => {
    const lastIndex = cards.length - 1;
    // If we're at the cloned first slide (index = lastIndex), jump to real first (index 1)
    if (currentIndex === lastIndex) {
      setIsTransitioning(false);
      setCurrentIndex(1);
      setTimeout(() => setIsTransitioning(true), 50);
    }
    // If we're at the cloned last slide (index = 0), jump to real last (index = originalCards.length)
    else if (currentIndex === 0) {
      setIsTransitioning(false);
      setCurrentIndex(originalCards.length);
      setTimeout(() => setIsTransitioning(true), 50);
    }
  };

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchDeltaX.current = 0;
    setIsPaused(true);
  };

  const onTouchMove = (e) => {
    touchDeltaX.current = e.touches[0].clientX - touchStartX.current;
  };

  const onTouchEnd = () => {
    if (touchDeltaX.current < -40) handleNext();
    else if (touchDeltaX.current > 40) handlePrev();
    touchDeltaX.current = 0;
    setIsPaused(false);
  };

  return (
    <section
      className="hero-section relative mb-16 sm:mb-20 bg-no-repeat bg-bottom"
      style={{
        background: "#FAF7F2",
        backgroundSize: "cover",
        backgroundPosition: "center bottom",
        backgroundAttachment: "scroll",
      }}
    >
      <div className="mx-auto px-4 sm:px-6 py-10 sm:py-16 lg:py-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          {/* LEFT CONTENT */}
          <div className="space-y-4 sm:space-y-6">
            <h1 className="text-3xl sm:text-4xl lg:text-4xl font-bold leading-tight text-gray-900">
              The Voice of <span className="text-[#da2128]">Indian Industry</span>
            </h1>

            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#faa61a] leading-tight !mt-[10px]">
              Shaping Bharat's Future
            </h2>

            <p className="text-[15px] sm:text-[18px] text-gray-600 max-w-lg leading-relaxed">
              The Associated Chambers of Commerce & Industry of India (ASSOCHAM) has been at the forefront of strengthening India's economic landscape for over a century.
            </p>

            <div className="flex flex-wrap gap-4 pt-2 sm:pt-4">
              <a
                href="#about-us"
                className="inline-flex items-center gap-2 px-6 py-3 sm:px-8 sm:py-3.5 hover:bg-[#f59c00] hover:text-white font-semibold rounded-xl border-2 border-[#f7941d] hover:border-white transition-all duration-300 text-sm sm:text-base"
              >
                Explore
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
            </div>
          </div>

          {/* RIGHT SIDE - SLIDER */}
          <div className="relative w-full">
            <div
              className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl"
              style={{ boxShadow: "2px 2px 2px 2px #9c9999" }}
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
            >
              {/*
                FIX: object-cover left-right crop kar raha tha kyunki banner image ka actual width:height
                ratio container ke ratio se zyada "wide" hai — cover height match karne ke liye image ko
                upscale karta hai aur sides se kaat deta hai. Ab object-contain use kar rahe hain jisse
                pura image bina kisi crop ke dikhega (chahe image kitni bhi wide/narrow ho); jo bhi khaali
                space left-right (ya top-bottom) bachega, use ek blurred backdrop copy se fill kar rahe hain
                taaki plain empty background na dikhe.
              */}
              <div className="relative w-full aspect-[4/3] sm:aspect-[16/9] rounded-2xl sm:rounded-3xl overflow-hidden">
                {loading && (
                  <div className="flex items-center justify-center h-full w-full bg-gray-100 animate-pulse text-gray-400 text-sm">
                    Loading...
                  </div>
                )}

                {!loading && cards.length === 0 && (
                  <div className="flex items-center justify-center h-full w-full bg-gray-100 text-gray-400 text-sm">
                    No banners found
                  </div>
                )}

                {!loading && cards.length > 0 && (
                  <div
                    className="flex h-full w-full"
                    onTransitionEnd={handleTransitionEnd}
                    style={{
                      transform: `translateX(-${currentIndex * 100}%)`,
                      transition: isTransitioning
                        ? "transform 1000ms cubic-bezier(0.4, 0, 0.2, 1)"
                        : "none",
                    }}
                  >
                    {cards.map((card, i) => (
                      <div key={i} className="relative h-full w-full shrink-0 bg-gray-900 overflow-hidden">
                        {/* Blurred backdrop fill — hides any empty space left by object-contain */}
                        <img
                          src={card.img}
                          alt=""
                          aria-hidden="true"
                          className="absolute inset-0 w-full h-full object-cover object-top blur-2xl scale-110 opacity-50"
                        />
                        {/* Actual banner image — object-contain so it NEVER gets cropped, aligned to top */}
                        <img
                          src={card.img}
                          alt={card.title}
                          className="relative w-full h-full object-contain object-top"
                          loading="eager"
                        />
                        <div className="absolute inset-0" />
                       <div className="absolute bottom-0 left-0 right-0 px-3 pb-2 sm:px-5 sm:pb-3 pt-6 sm:pt-10 bg-gradient-to-t from-black/95 via-black/80 to-transparent text-white">
  <div className="font-serif text-[10px] sm:text-xs lg:text-sm leading-snug px-2 py-1 sm:px-2.5 sm:py-1.5 rounded-md inline-block max-w-full line-clamp-2 bg-gradient-to-t from-black/95 via-black/80 to-transparent text-white">
    {card.title}
  </div>
</div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Left & Right Navigation Arrows */}
                {!loading && cards.length > 0 && (
                  <>
                    <button
                      onClick={handlePrev}
                      className="absolute left-2 sm:left-3 top-1/2 -translate-y-1/2 z-10 p-1.5 sm:p-2 rounded-full bg-black/40 backdrop-blur-sm text-white hover:bg-black/70 hover:scale-110 transition-all duration-300 focus:outline-none group"
                      aria-label="Previous slide"
                    >
                      <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6 group-hover:scale-110 transition-transform" />
                    </button>
                    <button
                      onClick={handleNext}
                      className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 z-10 p-1.5 sm:p-2 rounded-full bg-black/40 backdrop-blur-sm text-white hover:bg-black/70 hover:scale-110 transition-all duration-300 focus:outline-none group"
                      aria-label="Next slide"
                    >
                      <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6 group-hover:scale-110 transition-transform" />
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Floating Ticker */}
      <div className="absolute bottom-0 left-0 w-full z-20 translate-y-1/2 px-3 sm:px-6">
        <div className="max-w-8xl mx-auto">
          <div className="bg-[#FFFFFF] backdrop-blur-xl border border-[#FFFFFF] shadow-2xl rounded-xl sm:rounded-2xl overflow-hidden">
            <div className="flex items-center pr-2 sm:pr-[18px] min-w-0">
              {/* LIVE UPDATE LABEL */}
              <div className="bg-[#da2128]/50 hover:bg-[#da2128] hover:text-white px-2.5 sm:px-4 py-3 sm:py-4 flex items-center gap-1.5 sm:gap-2 font-semibold text-[10px] sm:text-xs md:text-sm whitespace-nowrap rounded-r-xl sm:rounded-r-2xl shadow-lg shrink-0">
                <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-[#FFFFFF] rounded-full animate-pulse" />
                <span className="hidden xs:inline">LIVE UPDATES</span>
                <span className="xs:hidden">LIVE UPDATES</span>
              </div>

              {/* TICKER */}
              <div className="flex-1 overflow-hidden px-2 sm:px-4 min-w-0">
                {tickerLoading && (
                  <div className="py-2.5 sm:py-3 text-xs sm:text-sm text-gray-400">
                    Loading updates...
                  </div>
                )}

                {!tickerLoading && horizontalTicker.length === 0 && (
                  <div className="py-2.5 sm:py-3 text-xs sm:text-sm text-gray-400">
                    No updates found
                  </div>
                )}

                {!tickerLoading && horizontalTicker.length > 0 && (
                  <div className="flex items-center gap-5 sm:gap-8 whitespace-nowrap animate-[tickerHorizontal_40s_linear_infinite] hover:[animation-play-state:paused] py-2.5 sm:py-3">
                    {horizontalTicker.map((item, i) => {
                      const Icon = item.icon;

                      return (
                        <a
                          key={i}
                          href={item.link || "#knowledge"}
                          target={item.link ? "_blank" : undefined}
                          rel={item.link ? "noopener noreferrer" : undefined}
                          className="flex items-center gap-2 text-gray-700 hover:text-[#B5121B] transition-colors m-[5px] shrink-0"
                        >
                          <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" />
                          <span className="text-xs sm:text-sm font-medium">
                            {item.text}
                          </span>
                          {item.isPdf && (
                            <span className="text-[9px] sm:text-[10px] font-bold text-[#da2128] border border-[#da2128] rounded px-1 leading-4">
                              PDF
                            </span>
                          )}
                        </a>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes tickerHorizontal {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .hero-section img {
          max-width: 100%;
        }

        @media (max-width: 639px) {
          .hero-section {
            background-attachment: scroll !important;
          }
        }

        @media (min-width: 1024px) {
          .hero-section {
            background-attachment: fixed;
          }
        }
      `}</style>
    </section>
  );
}